import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  image_upload_status: {
    additional_image_1: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    additional_image_2: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    additional_image_3: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    additional_image_4: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    additional_image_5: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    additional_image_6: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    }
  },
};

const image_retake_upload_slice = createSlice ({
  name: 'image_upload_status',
  initialState,
  reducers: {
    set_image_upload_status_retake: (state, action) => {
      const { image_name, status, type } = action.payload;
      console.log(image_name,status,type,"91")
      console.log(state.image_upload_status[image_name][type],"90")
      if (state.image_upload_status[image_name]) {
        state.image_upload_status[image_name][type] = status;
        console.log(state.image_upload_status[image_name][type],"94")
      } else {
        console.warn(`Image type ${image_name} does not exist in the state.`);
      }
    },
  },
});

export const {set_image_upload_status_retake} = image_retake_upload_slice.actions;

export default image_retake_upload_slice.reducer;
